/* eslint-disable default-case */
import React, { useState, useEffect } from 'react';
import {
   Button, Select, Row, Col, Typography, Image, Space, Input, Tooltip, Table,
   Modal, Tag, Grid, Spin, Empty
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import { useNavigate, Link } from 'react-router-dom';
import { SearchOutlined, EyeOutlined, ReloadOutlined, SolutionOutlined, CalendarOutlined } from '@ant-design/icons';
import axios from 'axios';
// import SimpleBarReact from "simplebar-react";
// import SideCalendar from '../../components/side-calendar/SideCalendar';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
// import RenderPDFViewer from '../../components/iframe-viewer/pdfViewer';
// import { PDFReader } from 'reactjs-pdf-reader';
// import { SchoolTerms } from '../../constants';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import Highlighter from 'react-highlight-words';
import './ReportCards.css';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
// import { RenderPDFReader } from '../../components/pdfreader/RenderPDFReader';
import { renderReportCardPdfError } from './ReportCardPdfError';
import ResponsiveDataCards from '../../components/responsive/ResponsiveDataCards';
import ResponsivePdfViewer from '../../components/document-viewer/ResponsivePdfViewer';

// var g_subdomain = "";
// var g_report_card_url = "";
var pdfFile = '';

var g_term_name = "";
var g_modal_title = "";
var g_report_card_url = "";
var g_subdomain = "";

const { Option } = Select;
const { Text } = Typography;

export function StudentReportCards() {
   const navigate = useNavigate();

   const screens = Grid.useBreakpoint();
   const useCardListView = !screens.lg;
   const isMobileView = !screens.md;
   // Keep the preview document clear of the sticky mobile menu bar and the modal header/footer
   const previewDocumentHeight = isMobileView ? 'max(240px, calc(100dvh - 260px))' : 'calc(100vh - 185px)';
   const previewImageHeight = isMobileView ? 'max(240px, calc(100dvh - 270px))' : 'calc(100vh - 195px)';

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [term, setTerm] = useState(null);
   const [fileURL, setFileURL] = useState(null);
   const [reportCard, setReportCard] = useState({
      allow: false,
      file_url: null,
   })
   const [rcaList, setRCAList] = useState([]);
   const [reportCardListLoading, setReportCardListLoading] = useState(false);
   const [modalVisible, setModalVisible] = useState(false);

   const [downloadStatus, setDownloadStatus] = React.useState(false);

   g_subdomain = localStorage.getItem("lms-subdomain");
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   useEffect(() => {
      Utils.verifyJwt();

      pdfFile = '';
      getReportCardsAwardsList();
   }, []);

   const getReportCardsAwardsList = () => {
      var url = `${process.env.REACT_APP_API_REPORT_CARD_UPLOAD}/rcalist?student_id=${user_id}&type=reportcard`;
      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;
            setRCAList(data);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleSearchReportCards = () => {
      pdfFile = '';

      setReportCard({
         allow: 0,
         file_url: null,
         subdomain: null,
      });

      var url = `${process.env.REACT_APP_API_REPORT_CARD_UPLOAD}/reportcardinfo?student_id=${user_id}&term=${term}`;
      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;
            // setFileURL(data.file_url);
            setReportCard({
               allow: data.allow_viewing,
               file_url: data.file_url,
               subdomain: localStorage.getItem("lms-subdomain"),
            });
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const ReportCardsListColumns = [
      {
         title: 'Type',
         key: 'term_name',
         dataIndex: 'term_name',
         sorter: (a, b) => { return a.term_name.localeCompare(b.term_name) },
         width: '30%'
      },
      {
         title: 'Viewing Date',
         key: 'viewing_schedule',
         dataIndex: 'viewing_schedule',
         sorter: (a, b) => { return a.viewing_schedule.localeCompare(b.viewing_schedule) },
         width: '35%'
      },
      {
         title: 'Viewing Status',
         key: 'allow_viewing_desc',
         // sorter: (a, b) => { return a.allow_viewing_desc.localeCompare(b.allow_viewing_desc)},
         sorter: (a, b) => { return (a.allow_viewing_desc === null ? '' : a.allow_viewing_desc).localeCompare(b.allow_viewing_desc === null ? '' : b.allow_viewing_desc) },
         render: payload => {
            return (
               <>
                  {payload.allow_viewing_desc !== null
                     ?
                     <Tag style={{ fontSize: 12 }} color={payload.allow_viewing === 0 ? 'red' : 'green'}>
                        {
                           payload.allow_viewing === 1
                              ?
                              payload.allow_viewing_desc
                              :
                              payload.with_back_accounts === 1
                                 ?
                                 'Not Allowed (With Balance)'
                                 :
                                 payload.allow_viewing_desc
                        }
                     </Tag>
                     :
                     <></>
                  }
               </>
            );
         },
         width: '18%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => renderReportCardViewAction(payload),
         width: '25%'
      },
   ].filter(item => !item.hidden);

   function renderReportCardViewAction(payload) {
      if (payload.file_url === null || payload.file_url === "") {
         return null;
      }

      return (
         <Tooltip placement="top" title={'View ' + payload.term_name}>
            <EyeOutlined color='#4abec7' style={{ cursor: 'pointer' }}
               onClick={() => handlePreview((payload.first_name + ' ' + payload.last_name), payload.file_url, payload.term_name, payload.allow_viewing, payload.is_on_schedule, payload.with_back_accounts)}
            />
         </Tooltip>
      );
   }

   const reportCardMobileFields = [
      {
         key: 'term_name',
         label: 'Type',
         dataIndex: 'term_name',
         span: 2,
         emphasis: true,
      },
      {
         key: 'viewing_schedule',
         label: 'Viewing Date',
         dataIndex: 'viewing_schedule',
         span: 2,
         render: (value) => (
            <span className="report-card-mobile-date">
               <CalendarOutlined /> {value || 'Not set'}
            </span>
         ),
      },
      {
         key: 'allow_viewing_desc',
         label: 'Viewing Status',
         dataIndex: 'allow_viewing_desc',
         render: (_, record) => (
            record.allow_viewing_desc !== null
               ? (
                  <Tag style={{ fontSize: 12 }} color={record.allow_viewing === 0 ? 'red' : 'green'}>
                     {
                        record.allow_viewing === 1
                           ?
                           record.allow_viewing_desc
                           :
                           record.with_back_accounts === 1
                              ?
                              'Not Allowed (With Balance)'
                              :
                              record.allow_viewing_desc
                     }
                  </Tag>
               )
               : '-'
         ),
      },
   ];

   function sPDFFile() {
      pdfFile = g_report_card_url;
      return true;
   }

   const renderPreviewer = (document) => {
      if (document !== null && document !== '' && modalVisible) {
         var re = /(?:\.([^.]+))?$/;
         var ext = re.exec(document.toLowerCase());

         var subdomain = localStorage.getItem("lms-subdomain");
         var url = `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${document}`;

         switch (ext[1]) {
            case "pdf":
               return <div
                  className="report-card-preview-document"
                  style={{ width: "100%", height: previewDocumentHeight }}
               >
                  <ResponsivePdfViewer
                     fileUrl={url}
                     height="100%"
                     pageLayout={{
                        transformSize: ({ size }) => ({
                           height: size.height + 30,
                           width: size.width + 30,
                        }),
                     }}
                     renderError={renderReportCardPdfError}
                  />
                  {/* <RenderPDFReader url={url} height={previewDocumentHeight} /> */}
                  {/* <RenderPDFViewer url={url} height={previewDocumentHeight} load={pdfFile !== document ? sPDFFile() : false} showdownload={false} showprint={false} showpagecontrols={true} showfullscreen={true} /> */}
               </div>

            case "png": case "jpg": case "jpeg":
               return <div
                  className={'modal-document-viewer report-card-preview-image'}
                  style={{ height: previewImageHeight }}
               >
                  <Image
                     src={url}
                     style={{ minHeight: previewImageHeight, maxHeight: previewImageHeight }}
                  />
               </div>
         }
      }
   }

   // const handlePreview = (student_name, report_card_url, term_name, allow_viewing, is_on_schedule) => {
   //    if (allow_viewing && is_on_schedule) {
   //       g_term_name = term_name;
   //       g_modal_title = student_name;
   //       g_report_card_url = report_card_url;
   //       g_subdomain = localStorage.getItem("lms-subdomain");
   //       setModalVisible(true);
   //    }
   //    else {
   //       Modal.error({
   //          title: 'Report Card',
   //          // content: 'Viewing of ' + term_name + ' is not yet allowed',
   //          content: 'Please coordinate with the accounting office. Thank you!',
   //          centered: true
   //       });
   //    }
   // }

   const handlePreview = (student_name, report_card_url, term_name, allow_viewing, is_on_schedule, with_back_accounts) => {
      // if (allow_viewing && is_on_schedule) {
      //    if (with_back_accounts) {
      //       Modal.error({
      //          title: 'Report Card',
      //          content: 'Please coordinate with the accounting office. Thank you!',
      //          centered: true
      //       });
      //    } else {
      //       g_term_name = term_name;
      //       g_modal_title = student_name;
      //       g_report_card_url = report_card_url;
      //       g_subdomain = localStorage.getItem("lms-subdomain");
      //       setModalVisible(true);
      //    }
      // }
      // else {
      //    Modal.info({
      //       title: 'Report Card',
      //       content: 'Viewing of ' + term_name + ' is not yet allowed',
      //       centered: true
      //    });
      // }
      if (is_on_schedule) {
         if (allow_viewing) {
            g_term_name = term_name;
            g_modal_title = student_name;
            g_report_card_url = report_card_url;
            g_subdomain = localStorage.getItem("lms-subdomain");
            setModalVisible(true);
         } else {
            if (with_back_accounts) {
               Modal.error({
                  title: 'Report Card',
                  content: 'Please coordinate with the accounting office. Thank you!',
                  centered: true
               });
            } else {
               Modal.info({
                  title: 'Report Card',
                  content: 'Report Card cannot be viewed at this time.',
                  centered: true
               });
            }
         }
      }
      else {
         Modal.info({
            title: 'Report Card',
            // content: 'Viewing of ' + term_name + ' is not yet allowed',
            content: 'Report Card cannot be viewed at this time.',
            centered: true
         });
      }
   }

   const _downloadFile = (url, name) => {
      setDownloadStatus(true);

      var re = new RegExp(' ', 'g');
      var file_name = name.replace(re, '_');
      var pos = url.lastIndexOf('.');
      var ext = url.slice(pos);

      fetch(url)
         .then(response => {
            response.blob().then(blob => {
               let url = window.URL.createObjectURL(blob);
               let a = document.createElement('a');
               a.href = url;
               a.download = file_name + ext;
               a.click();
               setDownloadStatus(false)
            });
         });
      /*setDownloadStatus(true)
         FileSaver.saveAs(currentS3ContentLink, downloadOfficeFileName)
      setDownloadStatus(false) */
   };

   const handleModalClose = () => {
      pdfFile = '';
      setModalVisible(false);
   }

   return (
      <>
         <div className="dashboard-area-all report-card-page">
            <div className="dashboard-item report-card-shell">
               <div className="report-card-breadcrumb">
                  {/* <ul>
                     <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                     <li><span>/</span></li>
                     <li><a className="active">Report Card & Certificates</a></li>
                     <li><span>/</span></li>
                     <li><a className="active">Report Card</a></li>
                  </ul> */}
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'rc', node: 'Report Card & Certificates' },
                        { key: 'report-card', node: 'Report Card' },
                     ]}
                  />
               </div>
               <section className="report-card-overview">
                  <span className="report-card-kicker">Report Card & Certificates</span>
                  <h1>Report Card</h1>
                  <p>View available report cards released for your account.</p>
                  <div className="report-card-meta">
                     <span><SolutionOutlined /> {reportCardListLoading ? 'Loading records' : `${rcaList.length} available record${rcaList.length === 1 ? '' : 's'}`}</span>
                  </div>
               </section>

            {/* <Row gutter={24} style={{paddingBottom: "10px"}}>
               <Col>
               <Text italic style={{fontSize: "12px"}}>Instructions: To view students Report Card, Step 1 - Click Select Term, Step 2 - Click View Button</Text>
               </Col>
            </Row>
            <Row gutter={24} style={{paddingBottom: "20px"}}>
               <Col span={6}>
                  <Select 
                     showArrow 
                     size='middle' 
                     style={{width: '100%'}} 
                     allowClear 
                     placeholder="Select Term" 
                     onChange={(val) => setTerm(val)} 
                     value={term}
                  >
                     {SchoolTerms.map(({value, name}, idx) => { 
                        return <Option value={value}>{name}</Option>
                     })}
                  </Select>
               </Col>
               <Col span={5}>
                  <Button className='button-shadow' type='primary' shape='round' block onClick={() => handleSearchReportCards()} icon={<EyeOutlined />}>View</Button>
                  
               </Col>
            </Row> */}
               <section className="report-card-panel">
                  <div className="report-card-panel-header">
                     <div>
                        <span className="report-card-kicker">Records</span>
                        <h2>Available Report Cards</h2>
                     </div>
                     <div className="report-card-refresh-row">
                  <Button className='button-shadow' type='primary' shape='round' onClick={() => getReportCardsAwardsList()} icon={<ReloadOutlined />}>Refresh List</Button>
                     </div>
                  </div>
                  <div className="report-card-table-shell">
                     {
                        reportCardListLoading
                           ?
                           <div className='report-card-empty'>
                              <Spin size='large' tip="Loading, please wait..." />
                           </div>
                           :
                           rcaList.length > 0
                              ? (
                                 useCardListView
                                    ? (
                                       <div>
                                          <ResponsiveDataCards
                                             dataSource={rcaList}
                                             rowKey="uid"
                                             fields={reportCardMobileFields}
                                             renderActions={(record) => renderReportCardViewAction(record)}
                                             emptyDescription="No records found"
                                          />
                                          <div className="report-card-mobile-footer">
                                             Total Records: {rcaList.length}
                                          </div>
                                       </div>
                                    )
                                    : (
                                       <Table
                                          rowKey={'uid'}
                                          loading={reportCardListLoading}
                                          size='small'
                                          columns={ReportCardsListColumns}
                                          dataSource={rcaList}
                                          pagination={false}
                                          scroll={{
                                             x: '650px',
                                             y: 'calc(100svh - 22rem)',
                                          }}
                                          style={{ minWidth: '650px' }}
                                          footer={() => 'Total Records: ' + rcaList.length}
                                       />
                                    )
                              )
                              : (
                                 <div className='report-card-empty'>
                                    <Empty image="../images/brainee_mascot.png" description="No records found" />
                                 </div>
                              )
                     }
                  </div>
               </section>

            {/* {
               reportCard.file_url !== null && reportCard.file_url !== ''
               ?
               <>
               {
                  reportCard.allow === 1
                  ?
                  <div className="report-card-container">
                     { renderPreviewer(reportCard.file_url) }
                  </div>
                  :
                  <div className='report-card-container_empty'>
                     <Empty description="To view Report Card please contact school business office or class adviser." style={{position:"relative", fontSize:"16px"}} />
                  </div>
               }
               </>
               :
               <div className='report-card-container_empty'>
                  <Empty description="Report Card not available." style={{position:"relative", fontSize:"16px"}} />
               </div>
            } */}

            </div>
         </div>
         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}

         <Modal
            title={"View " + g_term_name + " for " + g_modal_title}
            // okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={modalVisible}
            // width={window.innerWidth - 300}
            wrapClassName="report-card-preview-modal"
            width={isMobileView ? 'calc(100vw - 16px)' : '75%'}

            onCancel={() => { handleModalClose(); }}
            onOk={() => { handleModalClose(); }}
            footer={[
               <Row>
                  <Col span={12} style={{ textAlign: "left" }}>
                     {!g_term_name.includes("Report Card") &&
                        <Button shape='round'
                           type="primary"
                           loading={downloadStatus}
                           onClick={() => _downloadFile(`${process.env.REACT_APP_API_S3_URL}/${g_subdomain}/${g_report_card_url}`, g_term_name)}
                        >
                           Download
                        </Button>
                     }
                  </Col>
                  <Col span={12} style={{ textAlign: "right" }}>
                     <Button shape='round' className="modal-dismiss-btn" onClick={() => { handleModalClose(); }}>
                        Close
                     </Button>
                  </Col>
               </Row>,
            ]}
         >
            <div className='essay_list_container report-card-preview-body' style={{ background: "#fff" }}>
               {renderPreviewer(g_report_card_url)}
            </div>
         </Modal>
      </>
   );
}
